var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7875 3.21375C4.04625 1.39875 5.61 0 7.5 0C9.39 0 10.9537 1.39875 11.2125 3.2175C13.2562 3.38625 15 5.41875 15 7.99875C15 12.1425 11.25 16.125 7.5 17.9963C3.74625 16.1213 0 12.1425 0 7.99875C0 5.41875 1.7475 3.38625 3.7875 3.21375ZM10.4587 3.24C10.2188 1.82625 8.985 0.75 7.5 0.75C6.015 0.75 4.785 1.82625 4.545 3.24C5.38125 3.36 6.2325 3.8025 7.0125 4.65375L7.15125 4.81125C7.15125 4.81125 7.38375 5.09625 7.5 5.25375C7.6125 5.09625 7.84875 4.81125 7.84875 4.81125L7.9875 4.65375C8.7675 3.80625 9.6225 3.36375 10.455 3.24375L10.4587 3.24ZM7.5 17.1562C11.3138 15.1237 14.25 11.3813 14.25 8.0025C14.25 4.1925 10.4588 2.46375 8.1075 5.69625L7.5 6.52875L6.8925 5.6925C4.545 2.45625 0.75 4.18875 0.75 7.99875C0.75 11.3775 3.6825 15.12 7.5 17.1525V17.1562Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.274b922686e1040f7a9392f2ad40cac1.svg";
export { ForwardRef as ReactComponent };